import React from 'react'
import ReactDOM from 'react-dom'
import { GxIcon, GxModal } from '@garpix/garpix-web-components-react'
import style from '../styles/index.module.scss'
import { closeIcon } from '@/images'
import classNames from 'classnames'
import IconButton from '@/components/Button/IconButton'

const Modal = ({
  handleClose,
  children,
  noBody = false,
  wideBody = false,
  customStyle = '',
  full = false,
  ...props
}): React.ReactElement => {
  return ReactDOM.createPortal(
    <GxModal
      {...props}
      className={classNames({
        [style.default]: true,
        [style.no_body]: noBody,
        [style.full]: full,
        [style.wide]: wideBody,
        [style[`custom_${customStyle}`]]: Boolean(customStyle)
      })}
    >
      <IconButton
        slot='close-button'
        onClick={handleClose}
        className={classNames({
          [style.close_btn]: true,
          [style.no_body_close_btn]: noBody,
          [style.full_close_btn]: full,
          [style[`custom_${customStyle}_close_btn`]]: Boolean(customStyle)
        })}
      >
        <GxIcon
          src={closeIcon}
          className={classNames({
            [style.close_btn__icon]: true,
            [style.no_body_close_btn__icon]: noBody
          })}
        />
      </IconButton>
      {children}
    </GxModal>,
    document.body
  )
}

export default Modal
